module.exports = __webpack_public_path__ + "img/book-mark.63183bef.svg";